import { useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import axiosClient from '../api/interceptor-v2';

//fetch org list

const fetchOrgList = async ({ queryKey }) => {

  try {
    const [_key, minimal] = queryKey;
    const response = await axiosClient.get(`/organization`, {
      params: {
        minimal
      }
    })
    let data = response.data.result;
    return data;

  }
  catch (err) {

    console.error('fetchData error:', err.message);
    throw err;

  }

};

//fetch edit org data

const fetchEditOrgData = async ({ queryKey }) => {

  try {

      const [_key, orgId] = queryKey;

      console.log('fetchData inside---', {queryKey});

          if (!orgId) return;

          console.log('region inside', orgId)

          // Await the axios call to ensure you receive the response before proceeding
          const response = await axiosClient.get(`/organization?orgId=${orgId}`)
          let data = response.data.result;
          console.log('fetch response file xx', data)
          return data;

    } catch (err) {

        console.error('fetchData error:', err.message);
        throw err;

    }
  
};

//fetch edit org data

const fetchOrgCountryFieldData = async ({ queryKey }) => {

  try {

      const [_key, countryCode] = queryKey;

      console.log('fetchData inside---', {queryKey});

          if (!countryCode) return;

          console.log('countryCode inside', countryCode)

          // Await the axios call to ensure you receive the response before proceeding
          const response = await axiosClient.get(`/organization?countryCode=${countryCode}`)
          let data = response.data.result;
          console.log('fetch response file xx', data)
          return data;

    } catch (err) {

        console.error('fetchData error:', err.message);
        throw err;

    }
  
};


export function useOrgList(minimal = null) {
    return useQuery({
      queryKey: ['getOrgDatay', minimal],
        queryFn: fetchOrgList,
        cacheTime: 60 * 60 * 1000,
    });
}

export function useOrgEdit(orgId) {
  return useQuery({
      queryKey: ['editOrgData', orgId],
      queryFn: fetchEditOrgData,
      cacheTime: 60 * 60 * 1000, 
      enabled: !!orgId
  });
}

export function useOrgCountryFields(countryCode) {
  return useQuery({
      queryKey: ['orgCountryFieldData', countryCode],
      queryFn: fetchOrgCountryFieldData,
      cacheTime: 60 * 60 * 1000, 
      enabled: !!countryCode
  });
}


//upload org logo

export const useLogoUploadMutation = (
  files, 
  onSuccessCallback
) => {
  const queryClient = useQueryClient()

  return useMutation({
    // The function that actually performs the POST
    mutationKey: ['uploadLogo'],
    mutationFn: async () => {
      
      const formData = new FormData();
      formData.append('logo', files.at(0).file);

      // Perform the POST request
      const res = await axiosClient.post(`/settings`, formData)
      return res.data
    },

    // Handle what to do after success
    onSuccess: (data) => {
      const { result, error } = data

      // refetch other queries if needed
      //queryClient.invalidateQueries(["getDataRetain"])

      // Or trigger a callback
      if (onSuccessCallback) onSuccessCallback(data.result)

    },

    // Handle errors
    onError: (error) => {
      console.error("POST Mutation Error:", error)
    },
  })

}


//delete org logo

export const useLogoDeleteMutation = (
  onSuccessCallback
) => {
  const queryClient = useQueryClient()

  return useMutation({
    // The function that actually performs the POST
    mutationKey: ['deleteLogo'],
    mutationFn: async () => {

      // Perform the POST request
      const res = await axiosClient.delete(`/settings?deleteLogo=true`)
      return res.data
    },

    // Handle what to do after success
    onSuccess: (data) => {
      const { result, error } = data

      // refetch other queries if needed
      //queryClient.invalidateQueries(["getDataRetain"])

      // Or trigger a callback
      if (onSuccessCallback) onSuccessCallback(data.result)

    },

    // Handle errors
    onError: (error) => {
      console.error("POST Mutation Error:", error)
    },
  })

}

//add org

export const useOrgAddMutation = (
  onSuccessCallback
) => {
  
  const queryClient = useQueryClient()

  return useMutation({
    // The function that actually performs the POST
    mutationKey: ['addOrg'],
    mutationFn: async (data) => {

      // Perform the POST request
      const res = await axiosClient.post(`/organization`, data)
      return res.data
    },

    // Handle what to do after success
    onSuccess: (data) => {
      const { result, error } = data

      // refetch other queries if needed
      queryClient.invalidateQueries(["getOrgDatay"])

      // Or trigger a callback
      if (onSuccessCallback) onSuccessCallback(data.result)

    },

    // Handle errors
    onError: (error) => {
      console.error("POST Mutation Error:", error)
    },
  })

}

//update org

export const useOrgUpdateMutation = (
  onSuccessCallback
) => {
  
  const queryClient = useQueryClient()

  return useMutation({
    // The function that actually performs the POST
    mutationKey: ['updateOrg'],
    mutationFn: async (data) => {

      // Perform the POST request
      const res = await axiosClient.put(`/organization`, data)
      return res.data
    },

    // Handle what to do after success
    onSuccess: (data) => {
      const { result, error } = data

      // refetch other queries if needed
      queryClient.invalidateQueries(["getOrgDatay"])

      // Or trigger a callback
      if (onSuccessCallback) onSuccessCallback(data.result)

    },

    // Handle errors
    onError: (error) => {
      console.error("POST Mutation Error:", error)
    },
  })

}

//delete org 

export const useDeleteOrgMutation = (
  editId,
  onSuccessCallback
) => {
  const queryClient = useQueryClient()

  return useMutation({
    // The function that actually performs the POST
    mutationKey: ['deleteOrg'],
    mutationFn: async () => {

      const payload = {
        orgId:editId
      }

      // Perform the POST request
      const res = await axiosClient.delete(`/organization`, {data: payload})
      return res.data
    },

    // Handle what to do after success
    onSuccess: (data) => {
      const { result, error } = data

      // refetch other queries if needed
      queryClient.invalidateQueries(["getOrgDatay"])

      // Or trigger a callback
      if (onSuccessCallback) onSuccessCallback(data.result)

    },

    // Handle errors
    onError: (error) => {
      console.error("POST Mutation Error:", error)
    },
  })

}